import { Button } from "@/components/UI/Button";
import { TextField } from "@mui/material";
import { useState } from "react";
import { cubeCustomColors } from "../../../../tailwind.config";
import { useAuth0 } from "@auth0/auth0-react";
import { sendAxeImportData } from "@/services/AxeCreationSERVICES.";

const GenerateAxeSidebarContent = ({
  theme,
  getAccessTokenSilently,
}: {
  theme: string | undefined;
  getAccessTokenSilently: Function;
}) => {
  const defaultBorderColor = "info";
  const defaultHelperText = "Enter Axe messages here";

  const [borderColor, setBorderColor] = useState<
    "primary" | "error" | "secondary" | "info" | "success" | "warning"
  >(defaultBorderColor);
  const [helperText, setHelperText] = useState(defaultHelperText);
  const [axeInputValue, setAxeInputValue] = useState("");
  const { user } = useAuth0();

  return (
    <div className=" m-2 p-1">
      <div>
        <TextField
          onChange={(e) => {
            setBorderColor(defaultBorderColor);
            setHelperText(defaultHelperText);
            setAxeInputValue(e.target.value);
          }}
          id="axeInput"
          value={axeInputValue}
          placeholder=""
          multiline
          variant="outlined"
          minRows={6}
          // color={textColor}
          focused
          helperText={helperText}
          size="small"
          sx={{
            "& .MuiOutlinedInput-root": {
              color: theme == "dark" ? "#E1E1E1" : "#363737",
              fontSize: "12px",
              "&.Mui-focused": {
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    borderColor == "success"
                      ? "#06AA6D"
                      : borderColor == "error"
                        ? cubeCustomColors.ButtonColour[100]
                        : borderColor == "warning"
                          ? "#FF771F"
                          : "#5DA2D2",
                  borderWidth: "1px",
                },
              },
            },
            "& .MuiFormHelperText-root": {
              color: theme == "dark" ? "#E1E1E1" : "#363737",
            },
          }}
        />
        <Button
          variant="mainBlueAction"
          size={"button_sm_mainBlueAction"}
          data-testid="selectPanelBtn"
          onClick={() => {
            const newOutput = axeInputValue.replace(/(?:\r\n|\r|\n)/g, " \\n ");
            sendAxeImportData(
              newOutput,
              user,
              getAccessTokenSilently,
              setBorderColor,
              setHelperText,
            );
          }}
        >
          Generate Axes
        </Button>
      </div>
    </div>
  );
};

export default GenerateAxeSidebarContent;
